import React from "react";
import { Form, Switch } from "antd";
import "./ProjectSettingToggle.css";

const ProjectSettingToggle = React.forwardRef(function ProjectSettingToggle(
  {
    name,
    title,
    description,
    initialValue,
    checked,
    disabled,
    onChange,
    ...rest
  },
  ref
) {
  const control = (
    <Switch
      aria-label={title}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
  );

  return (
    <div
      ref={ref}
      {...rest}
      className={`project-setting-toggle${
        description ? "" : " project-setting-toggle--compact"
      }`}
    >
      <div className="project-setting-toggle__copy">
        <div className="project-setting-toggle__title">{title}</div>
        {description && (
          <div className="project-setting-toggle__description">{description}</div>
        )}
      </div>
      {name ? (
        <Form.Item
          name={name}
          valuePropName="checked"
          initialValue={initialValue}
          className="project-setting-toggle__control"
        >
          {control}
        </Form.Item>
      ) : (
        <div className="project-setting-toggle__control">{control}</div>
      )}
    </div>
  );
});

export default ProjectSettingToggle;
